<template>
  <div class="card">
    <div v-if="slots.header" class="card-header">
      <slot name="header">
        {{ name }}
      </slot>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
    <div class="card-footer" v-if="slots.footer">
        <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { useSlots } from "vue";
export default {
  props: ["name"],
  data() {
    return {
      slots: useSlots(),
    };
  },
};
</script>

<style>
</style>